import type { ReactNode } from "react";
import rabbitUrl from "../assets/nebula-rabbit.png";

// 清單空掉時的那一塊。兔子是名片上的吉祥物,擺在這裡讓空畫面不像壞掉的畫面。
//
// **兔子是裝飾,不是資訊。** 圖一律 aria-hidden + alt="",它不進無障礙樹;
// 「為什麼是空的」與「接下來做什麼」全部由文字承擔 —— 把圖整張拿掉,
// 這一塊仍然要說得清楚。看不到圖的人(螢幕閱讀器、圖片載入失敗、關掉圖片)
// 不該因此少知道任何一件事。
//
// 金黃細線是分隔,不是狀態:它只出現在圖與文字之間,沒有任何語意掛在上面。

export interface EmptyStateProps {
  /** 為什麼這裡是空的。一句話,單獨一個元素 —— 測試與螢幕閱讀器都照這一句抓。 */
  title: string;
  /** 接下來該做什麼。圖拿掉之後,這句話要自己站得住。 */
  description?: ReactNode;
  /** 文案說得出口的動作,旁邊就要有按鈕。 */
  action?: ReactNode;
  /** 兔子的高度。清單頁給大一點,塞在區塊裡的給小一點。 */
  size?: "sm" | "md";
  className?: string;
}

const RABBIT_HEIGHT: Record<"sm" | "md", string> = {
  sm: "h-16",
  md: "h-24",
};

export function EmptyState({
  title,
  description,
  action,
  size = "md",
  className = "",
}: EmptyStateProps) {
  return (
    <div
      data-testid="nq-empty-state"
      className={
        "flex flex-col items-center gap-2 rounded-[var(--radius)] border border-dashed " +
        "border-[var(--border-strong)] bg-[var(--surface)] px-4 py-10 text-center " +
        className
      }
    >
      <img
        src={rabbitUrl}
        alt=""
        aria-hidden="true"
        draggable={false}
        className={`${RABBIT_HEIGHT[size]} w-auto select-none`}
      />

      {/* 金黃細線。純裝飾的分隔,所以是色塊不是文字,也不承載任何狀態。 */}
      <span aria-hidden="true" className="block h-px w-10 rounded-full bg-brand-gold" />

      <p className="m-0 text-base font-medium text-[var(--text)]">{title}</p>
      {description ? <p className="m-0 text-sm text-[var(--text-3)]">{description}</p> : null}
      {action}
    </div>
  );
}
